import React, { createContext, useReducer } from 'react';

export enum ActionTypes {
  SET_STAGE_AND_TEXT_TYPE = 'SET_STAGE_AND_TEXT_TYPE',
}

const initialState: IState = {
  stage: '',
  textType: '',
};

export interface IState {
  stage: string;
  textType: string;
}

export interface IAction {
  type: string;
  payload: { stage: string; textType: string };
}

type Dispatch = {
  state: typeof initialState;
  dispatch: (action: IAction) => void;
  setStageAndTextType: (stage: string, textType: string) => void;
};

const lessonReducer = (state: IState, action: IAction): IState => {
  switch (action.type) {
    case ActionTypes.SET_STAGE_AND_TEXT_TYPE:
      return {
        ...state,
        stage: action.payload.stage as string,
        textType: action.payload.textType as string,
      };
    default:
      return state;
  }
};

export const LessonContext = createContext<Dispatch>({
  state: initialState,
  dispatch: () => false,
  setStageAndTextType: () => null,
});

export const LessonProvider: React.FC = ({ children }): JSX.Element => {
  const [state, dispatch] = useReducer(lessonReducer, initialState);

  const setStageAndTextType = (stage: string, textType: string) => {
    dispatch({ type: ActionTypes.SET_STAGE_AND_TEXT_TYPE, payload: { stage, textType } });
  };

  return (
    <LessonContext.Provider
      value={{
        state,
        dispatch,
        setStageAndTextType,
      }}
    >
      {children}
    </LessonContext.Provider>
  );
};
